const fetchHistory = async (channelId, pubnubInstance, startTime, endTime) => {
    const requestPayload = {
        channels: [channelId],
        includeMeta: true,
        start: startTime,
        end: endTime,
    };
    try {
        const responese = await pubnubInstance.fetchMessages(requestPayload);
        const channelMessages = (responese.channels[channelId] || []);
        if (channelMessages.length === 100 && channelMessages[0]?.timetoken) {
            // 100 is max limit of pubnub response message count
            const pastMessages = await fetchHistory(channelId, pubnubInstance, channelMessages[0].timetoken, undefined);
            return [...pastMessages, ...channelMessages];
        }
        return channelMessages;
    }
    catch (error) {
        const e = error instanceof Error ? error.message : JSON.stringify(error);
        throw new Error('Fetching History failed', { cause: e });
    }
};
export default fetchHistory;
//# sourceMappingURL=fetch-pubnub-history.js.map